<script setup lang="ts">
import { ref } from 'vue'
import type HeaderArea from '~/components/HeaderArea.vue'
import FooterArea from '~/components/FooterArea.vue'

const headerArea = ref<InstanceType<typeof HeaderArea> | null>(null)
</script>

<template>
  <div>
    <HeaderArea ref="headerArea" />
    <div>
      <slot />
    </div>
    <FooterArea />
  </div>
</template>
